import { ReactNode } from 'react';
import { atom } from 'recoil';

interface ModalAtomValueType {
  isOpen: boolean;
  child: ReactNode;
}

const modalAtom = atom<ModalAtomValueType>({
  key: 'modalAtomKey',
  default: { isOpen: false, child: null },
});

export default modalAtom;
